import { CareerLessonDetailQuery } from 'core';

type ExerciseNode = NonNullable<NonNullable<CareerLessonDetailQuery['careerLesson']>['exercise']>;

export type ExerciseFieldKind =
  | 'short_text'
  | 'long_text'
  | 'email'
  | 'phone'
  | 'url'
  | 'date'
  | 'month_year'
  | 'yes_no'
  | 'rating'
  | 'single_choice'
  | 'multi_choice'
  | 'skills'
  | 'photo'
  | 'repeat_group';

export interface ICareerExerciseField {
  id: string;
  label: string;
  helpText: string;
  placeholder: string;
  fieldType: ExerciseFieldKind;
  required: boolean;
  options: string[];
  maxLength: number | null;
  /** Куда ответ уходит в резюме. Пусто — никуда. */
  binding: string;
  /** Подсказка от сервера. Есть ТОЛЬКО пока анкета не сдана. */
  prefill: unknown;
}

export interface ICareerExercise {
  id: string;
  intro: string;
  outro: string;
  fields: ICareerExerciseField[];
  /** Ответы прошлой сдачи. `null` — анкета ещё не заполнялась. */
  answers: Record<string, unknown> | null;
  submittedAt: string | null;
}

/**
 * ТЗ 0039. Приводит анкету к виду, удобному форме.
 *
 * `prefill` приходит строкой JSON (`JSONString` на проводе) — разбираем здесь,
 * а не в компоненте: иначе каждый виджет разбирал бы её сам и по-своему.
 */
export const transformCareerExercise = (
  node: ExerciseNode | null | undefined,
): ICareerExercise | null => {
  if (!node) return null;

  const answers = node.mySubmission
    ? node.mySubmission.answers.reduce<Record<string, unknown>>((acc, item) => {
        acc[item.fieldId] = parseJson(item.value);
        return acc;
      }, {})
    : null;

  return {
    id: node.id,
    intro: node.intro,
    outro: node.outro,
    submittedAt: node.mySubmission?.submittedAt ?? null,
    answers,
    fields: node.fields.map((field) => ({
      id: field.id,
      label: field.label,
      helpText: field.helpText,
      placeholder: field.placeholder,
      fieldType: field.fieldType as ExerciseFieldKind,
      required: field.required,
      options: [...(field.options ?? [])],
      maxLength: field.maxLength ?? null,
      binding: field.binding,
      prefill: parseJson(field.prefill),
    })),
  };
};

const parseJson = (raw: unknown): unknown => {
  if (raw === null || raw === undefined) return null;
  if (typeof raw !== 'string') return raw;
  try {
    return JSON.parse(raw);
  } catch {
    // Сервер прислал не-JSON — отдаём как есть, это лучше, чем уронить форму.
    return raw;
  }
};
